import {Component, input, output} from '@angular/core';

@Component({
  selector: 'app-rating-review-filter',
  templateUrl: './rating-review-filter.component.html',
  styleUrls: ['./rating-review-filter.component.scss']
})
export class RatingReviewFilterComponent {

  readonly title = input<string>();
  readonly checked = input<boolean>(false);

  readonly checkedChange = output<boolean>();

  onClick() {
    this.setFilter(!this.checked());
  }

  setFilter(checked: boolean) {
    this.checkedChange.emit(checked);
  }
}
